module.exports = __webpack_public_path__ + "h5/img/jieshao_06.ef8560d7.jpg";